import React, { Component } from 'react';
import { safeParse } from '../utils';
import Breadcrumbs from './Breadcrumbs';

class App extends Component {

  render() {
    const data = this.props?.data || {}
    const host = data?.helmet?.host || 'himavangard.ru'
    const isArticle = data?.template === 5
    // Дата публикации лежит в контенте новости: <span class="news-date-time">24.06.2025</span>
    const dateMatch = typeof data?.content === 'string' ? data.content.match(/news-date-time[^>]*>\s*(\d{2})\.(\d{2})\.(\d{4})/) : null
    const datePublished = dateMatch ? `${dateMatch[3]}-${dateMatch[2]}-${dateMatch[1]}` : null

    return (
      <div className='mt-[95px] xl:mt-[150px] leading-none'>
        {isArticle &&
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Article",
              "headline": data?.pagetitle,
              "description": data?.helmet?.description || data?.introtext || '',
              "url": `https://${host}${data?.url || ''}`,
              ...(datePublished ? { "datePublished": datePublished } : {}),
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": `https://${host}${data?.url || ''}`
              },
              "author": {
                "@type": "Organization",
                "name": "ПКФ ХимАвангард",
                "url": `https://${host}/`
              },
              "publisher": {
                "@type": "Organization",
                "name": "ПКФ ХимАвангард",
                "url": `https://${host}/`
              }
            })}
          </script>
        }
        <div className='container'>
          <Breadcrumbs breadcrumbs={data?.breadcrumbs} />
          <h1 className='font-medium mt-[30px] xl:mt-[40px] tracking-[-0.04em] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start'>
            {safeParse(data?.pagetitle)}
          </h1>
          <div className='mt-[10px] text-black/60 text-[14px] xl:text-[16px] text-center xl:text-start page_content'>{safeParse(data?.content)}</div>
        </div>
      </div>
    );
  }
}

export default App;